import firebase from "firebase";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyBC0GfCvktvKIVlBtNhWdPLA_hQqllw5pk",
    authDomain: "critfail.firebaseapp.com",
    projectId: "critfail",
    storageBucket: "critfail.appspot.com",
    messagingSenderId: "26799596618",
    appId: "1:26799596618:web:52eef4928094ad26ed32b3",
    measurementId: "G-H3CXW9CGN5"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();
const storage = firebase.storage();

export { auth, provider, storage };
export default db;